module.exports = __webpack_public_path__ + "source/img/robot-sad.632aa635.png";